module.exports = __webpack_public_path__ + "img/title1_bg.04bf370f.png";